import React, { useRef, useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import HeroSection from '../components/home/HeroSection';
import VideoSection from '../components/home/VideoSection';
import BankLogoSection from '../components/home/BankLogoSection';
import ProductsSection from '../components/home/ProductsSection';
import FeatureSection from '../components/home/FeatureSection';
import DeveloperSection from '../components/home/DeveloperSection';
import TestimonialSection from '../components/home/TestimonialSection';
import FAQSection from '../components/home/FAQSection';
import TerminalSection from '../components/home/TerminalSection';
import styles from '../styles/home.module.css';
import enat from '../assets/LOGOS-12.svg';
import ahad from '../assets/ahadu.jpeg';

import hibretLogo from '../assets/hibret.png';
import awashLogo from '../assets/awash.png';
import bunaLogo from '../assets/buna.png';
import cbeLogo from '../assets/cbe.png';
import enatLogo from '../assets/enat.jpeg';
import absiniyaLogo from '../assets/absiniya.png';
import zemenLogo from '../assets/zemen.png';
import gateway from '../assets/gateway.jpg';
import payment from '../assets/merchant1.JPG';
import pos from '../assets/become.jpg';
import customer1 from '../assets/image2.png';
import customer2 from '../assets/customer2.png';
import customer3 from '../assets/asho.png';
import customer4 from '../assets/beteZata.png';
import showcaseImage from '../assets/arifdev.png';
import terminalImage from '../assets/home.jpg';
import abay from '../assets/abay.jpeg';
import ahadu from '../assets/ahadu.png';
import nib from '../assets/nib.jpeg';
import brehan from '../assets/brehan.png';
import addis from '../assets/addis.jpeg';
import coop from '../assets/coop.png';
import dashen from '../assets/dashen.png';
import tsehay from '../assets/tsehay.jpeg';
import wegagen from '../assets/wegagen.png';
import sinqee from '../assets/sinqe.png';
import oromia from '../assets/oromia.png';
import hijira from '../assets/hijra.jpeg';
import video from '../assets/arifVideo.mp4';
import smart from '../assets/smart.JPG';
import quickRespons from '../assets/qr1.png';
import remit from '../assets/remitance.JPG';
import merchant from '../assets/merchants.png';
import arifEqub from '../assets/ArifEqubPersons.png';
import parking from '../assets/insure2.jpg';
import commerce from '../assets/ecommerce.jpg';
import hospital from '../assets/CREDIT.jpg';
import wallet from '../assets/walletNew.jpg';
import mpesa from '../assets/mpesaa.png';
import kacha from '../assets/kachha.png';
import helo from '../assets/hello.png';
import yaya from '../assets/yaya.svg';
import visa from '../assets/visa1.png';
import master from '../assets/master.png';
import telebirr from '../assets/telebirr.png';
import partnersAddisBank from '../assets/Partners-AddisBank.png';
import partnersDashen from '../assets/Partners-Dashen.png';
import partnersTsehay from '../assets/Partners-Tsehay.png';
import partnersYango from '../assets/Partners-Yango.png';
import { homeFaqs } from '../seo/config';

const AnimatedText = ({ children, from = "top", delay = 0 }) => {
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible");
        } else {
          entry.target.classList.remove("visible");
        }
      },
      { threshold: 0.3, rootMargin: "0px 0px -50px 0px" }
    );

    if (ref.current) observer.observe(ref.current);

    return () => ref.current && observer.unobserve(ref.current);
  }, []);

  const direction = from === "top" ? "-60px" : "60px";

  return (
    <div
      ref={ref}
      style={{
        opacity: 0,
        transform: `translateY(${direction})`,
        transition: "opacity 0.9s ease-out, transform 0.9s ease-out",
        transitionDelay: `${delay}s`,
      }}
      className="animate-text"
    >
      {children}

      <style jsx>{`
        .animate-text.visible {
          opacity: 1 !important;
          transform: translateY(0) !important;
        }
        /* Ensure no overflow during animation */
        .animate-text {
          overflow: hidden;
        }
      `}</style>
    </div>
  );
};

const Home = () => {
  // Bank logos data
  const bankLogos = [
    { src: hibretLogo, alt: "Hibret Bank" },
    { src: telebirr, alt: "telebirr", className: styles.view },
    { src: abay, alt: "Abbay Bank" },
    { src: awashLogo, alt: "Awash Bank" },
    { src: ahadu, alt: "Ahadu Bank", className: styles.CBE },
    { src: bunaLogo, alt: "Buna Bank" },
    { src: nib, alt: "Nib Bank" },
    { src: cbeLogo, alt: "CBE", className: styles.view },
    { src: brehan, alt: "Brehan Bank", className: styles.CBE },
    { src: enatLogo, alt: "Enat Bank" },
    { src: addis, alt: "Addis I Bank" },
    { src: coop, alt: "COOP Bank", className: styles.view },
    { src: master, alt: "Master Card", className: styles.view },
    { src: visa, alt: "Visa", className: styles.view },
    { src: absiniyaLogo, alt: "Absiniya Bank", className: styles.view },
    { src: zemenLogo, alt: "Zemen Bank" },
    { src: dashen, alt: "dashen Bank", className: styles.view },
    // { src: tsehay, alt: "Tsehay Bank" },
    { src: wegagen, alt: "Wegagen Bank" },
    { src: sinqee, alt: "Sinqe Bank" },
    { src: oromia, alt: "Oromia Bank" },
    { src: hijira, alt: "Hijra Bank" },
    { src: mpesa, alt: "M-Pesa" },
    { src: helo, alt: "Hello Cash", className: styles.view },
    { src: kacha, alt: "Kacha" },
    { src: yaya, alt: "Yaya", className: styles.view },
    { src: partnersAddisBank, alt: "Addis Bank" },
    { src: partnersDashen, alt: "Dashen Bank" },
    { src: partnersTsehay, alt: "Tsehay Bank" },
    { src: partnersYango, alt: "Yango" },
  ];

  // Products data
  const productsData = [
    {
      name: "Arif ONLINE PAYMENT",
      image: gateway,
      features: [
        "Seamless Online Integration",
        "Multi-Channel Payment Support",
        "Advanced Security and Reliability",
      ],
      learnMoreLink: "/Gateway",
    },
    {
      name: "ARIF REMIT",
      image: remit,
      features: [
        "Fast and Secure Transfers",
        "Multi-Currency Support",
        "User-Friendly Interface",
        "Real-Time Tracking",
      ],
      learnMoreLink: "/Remittance",
    },
    {
      name: "ARIFQR",
      image: quickRespons,
      features: [
        "Convenient and Secure",
        "Transactions",
        "Wide Merchant Acceptance",
        "Cost-Effective for Businesses",
        "Real-Time Tracking and Integration",
      ],
      learnMoreLink: "/QrPayment",
    },
    {
      name: "ARIFPOS",
      image: smart,
      features: [
        "Versatile Payment Acceptance",
        "Enhanced Business Efficiency",
        "User-Friendly and Scalable",
        "Nationwide Connectivity",
      ],
      learnMoreLink: "/SmartPos",
    },
       {
      name: "ARIF M-POS",
      image: smart,
      features: [
        "True Mobility and Portability ",
        "Lower Setup and Maintenance Costs",
        "Scalability for All Business Sizes",
      ],
      learnMoreLink: "/MobilePos",
    },
    {
      name: "ARIF MERCHANT",
      image: merchant,
      features: [
        "Product Management",
        "Payment Processing",
        "Customer Management",
        "Discount and Promotions",
      ],
      learnMoreLink: "/MerchantApp",
    },
    {
      name: "ARIF EQUB",
      image: arifEqub,
      features: [
        "Digital group savings in ETB",
        "Live ledgers and automated draws",
        "Secure contributions held in escrow",
      ],
      learnMoreLink: "/ArifEqub",
    },
    {
      name: "ARIF INSURANCE",
      image: parking,
      features: [
        "Register, manage, and claim insurance",
        "Encrypted policies with real-time notifications and tracking",
        "Tailored plans for individuals and businesses ",
      ],
      learnMoreLink: "/CarParking",
    },
    {
      name: "ARIF WALLET",
      image: wallet,
      features: [
        "Interoperable, Group & Scheduled Payments",
        "Built-in Credit & Loyalty Systems",
        "Bill Payments, Airtime & Utilities",
        "Marketplace, Insurance & In-App Services",
      ],
      learnMoreLink: "/Wallet",
    },
    {
      name: "ARIF CREDIT",
      image: hospital,
      features: [
        "Flexible Repayment Options",
        "AI-Driven Scoring",
        "For Individuals & Merchants",
      ],
      learnMoreLink: "/HealthCare",
    },
    {
      name: "ARIFSHOP",
      image: commerce,
      features: [
        "Shop Across Verified Vendors",
        "Real-Time Order & Delivery Tracking",
        "Vendor Tools: Pricing, Promotions, Analytics",
        "BNPL, Discounts, Reviews & Loyalty Points",
      ],
      learnMoreLink: "/Ecommerce",
    },
  ];

  // Testimonials data
  const testimonials = [
    {
      name: "Nathan Dametew",
      title: "Chief Executive Officer, Yeneta Code",
      img: customer2,
      text: "At Yeneta Code, we are proud to collaborate with Arifpay in expanding access to digital education. Their reliable and localized fintech infrastructure supports our learners and educators in seamless transactions, enabling a more efficient and inclusive learning environment. Arifpay's commitment to innovation and impact makes them more than a service provider—they are a true partner in our mission.",
    },
    {
      name: "Binyam Teshome kumlachew",
      title: "Director, Finance & Administration @ ARSHO Medical Laboratories PLC",
      img: customer3,
      text: "Patients used to get frustrated with long queues and limited payment options. Since introducing ArifPay's POS system, that's changed completely. Now, patients can tap their cards and pay in seconds with ease. Even elderly patients have picked it up quickly. It's user-friendly, fast, and has made my job at the billing counter so much smoother. The support team is always responsive and helpful. It's more than just a payment system—it's a step into the future of healthcare finance.",
    },
    {
      name: "Rafatowel Worku",
      title: "Chief Operating Officer, ArtsTV",
      img: customer1,
      text: "Working with Arifpay has transformed the way we integrate technology into our media services. Their innovative payment solutions have allowed us to streamline subscription access and enhance viewer engagement. The Arifpay team brings not only technical expertise but also a deep understanding of the local ecosystem—making them a trusted partner in driving digital media forward.",
    },
    {
      name: "Dr. Helina Mekuria",
      title: " Deputy Medical Director of Bethzatha Internal Medicine Speciality Centre",
      img: customer4,
      text: "From day one, ArifPay's POS solution has proven to be fast, secure, and dependable. Our staff can focus more on patient care while the system handles real-time payment tracking across departments. The support team is always responsive and helpful. It's more than just a payment system—it's a step into the future of healthcare finance.",
    },
        {
      name: "Enat Bank ",
      title: "Enat bank testimonies ",
      img: enat,
      text: "With a shared commitment to empowering communities, Arifpay has been a trusted partner in expanding our digital presence. Their payment solutions have not only simplified transactions but also strengthened our mission of accessible banking for women and families.",
    },
    {
      name: "Ahadu Bank",
      title: "Ahadu bank testimonies",
      img: ahad,
      text: "Arifpay’s solutions/platforms has significantly enhanced our ability to serve digital-first customers. Their team’s agility, deep fintech expertise, and innovative tools have helped us provide flexible and smart financial solutions to our a rapidly growing user base.",
    },
  ];

  // FAQ data
  const faqs = homeFaqs;

  return (
    <div>
      <Header />
      <div className={styles.page}>

      <div className={styles.container}>
        <HeroSection
          title="The Leading Ethiopian Fintech Platform"
          subtitle="Welcome to Arifpay"
          description="Modern payments made for Ethiopia's digital economy. Whether you're saving, spending, or scaling — accept payments and integrate APIs with confidence."
          ctaText="Get a Started"
          ctaLink="/Partners"
          secondaryCtaText="Join Our Payment Gateway"
          secondaryCtaLink="https://dashboard.arifpay.net/auth/register"
        />

        <VideoSection videoSrc={video} />

        <BankLogoSection logos={bankLogos} />

        <ProductsSection title="Our Products" products={productsData} />

        <FeatureSection
          title="Become An Arif Merchant"
          description="Create best-in-class experiences to reach your customers every place they want to shop - in person, on social media, or online."
          bulletPoint="Accelerate your payment processing and access financial services right at your fingertips, fueling the growth of your business."
          buttonText="Become a Merchant"
          buttonLink="/MerchantApp"
          image={payment}
          imageAlt="feature payment"
        />

        <FeatureSection
          title="Become An Arif Partner"
          description="Arifpay works through a network of commercial channel partners."
          bulletPoint="Become an Arif Partner and share up to 70% of revenue."
          buttonText="Become a Partner"
          buttonLink="/Partners"
          image={pos}
          imageAlt="feature payment"
          reverse={true}
          sectionClass={styles.cont}
        />

        <DeveloperSection
          title="Arif Developer"
          description="Get the best API integration in Ethiopia. Build online, mobile, and in-person commerce experiences that connect more customers and sellers."
          bulletPoint="Arifpay APIs and SDKs are free for developers to use. Merchants and Customers only pay processing fees for each transaction."
          buttonText="Go to Arif Developer Portal"
          buttonLink="https://developer.arifpay.net/"
          image={showcaseImage}
          imageAlt="Arifpay developer API integration"
        />

        <TestimonialSection
          subtitle="TESTIMONIALS"
          title="Customer said about Arifpay Platform"
          testimonials={testimonials}
        />

        <FAQSection
          title="FAQ"
          subtitle="Awesome features optimizing your payment system"
          description="Explore to learn more about how Arifpay can empower your business with its solutions."
          faqs={faqs}
        />

        <TerminalSection
          title="The Right Terminals For Your Business"
          description="Our wide range of payment terminals is adapted to every use case. Whether you need in-store, mobile, or self-service solutions, there is a terminal tailored to your business needs."
          buttonText="Contact Us"
          buttonLink="/ContactUs"
          image={terminalImage}
          imageAlt="Payment Terminal"
        />
      </div>
      </div>

      <Footer />
    </div>
  );
};

export default Home;

